// libs
import classNames from 'classnames'
import React, { useCallback } from 'react'

// component
import Icon from 'src/components/forms/icon/icon'
import Popover from 'src/components/popover/popover'
import Reactions from 'src/components/post/shared/reactions/reactions'
import UserOnboardingCTA from 'src/containers/smart_components/user_onboarding_cta/user_onboarding_cta'

// constants
import { CLASS_PREFIX } from 'src/constants/'
import { textResources } from 'src/lang/de'

// helpers
import { translateReactions } from 'src/utils/reactions'

import './reactions_button.scss'
import { ReactionFragmentFragment, ReactionName } from '@lopo-tech/lopo-api'
import { IRenderAPI } from 'src/components/_libs/popover_lib/popover_lib'

interface IProps {
  reactableId: string;
  reactions: ReactionFragmentFragment;
  disabled?: boolean
}

const cls = CLASS_PREFIX + 'reaction_compact'
const wrapperCls = CLASS_PREFIX + 'reactions_compact'

const ReactionCompact = ({ name }: { name: ReactionName | 'DEFAULT_CANDLE'}) =>
  <div className={classNames(cls, `${cls}--${name}`)} />

const ReactionIcon = ({ iconName }: { iconName: string }) =>
  <Icon className={classNames(cls, `${cls}--${iconName}`)}
    name={iconName}
    size={16}
  />

export const ReactionsCompact: React.FC<IProps> = ({ reactableId, reactions, disabled }) => {
  const isCandlePost = reactions.availableReactions.some(
    (name) => name === ReactionName.Candle
  )

  const zeroReactionsText = isCandlePost
    ? textResources.reactions.condolences
    : textResources.reactions.like

  const myReaction = reactions.ownReaction
  const activeWrapper = myReaction && wrapperCls + '--active'
  const countCls = classNames({
    [wrapperCls + '__count']: true,
    [wrapperCls + '__count--active']: !!myReaction
  })

  const reactionCount = reactions.receivedReactions.reduce((acc, { count }) => acc + count, 0)

  const renderPopoverChildren = useCallback(({ hide }: IRenderAPI) => {
    return (
      <Reactions
        reactableId={reactableId}
        reactions={reactions}
        onClose={hide}
        canReact={!disabled}
      />
    )
  }, [reactions, reactableId, disabled])

  return (
    <UserOnboardingCTA active={!!disabled} gtmSourceName="reactions">
      <Popover
        position={'top'}
        align={reactionCount > 3 ? 'relative' : 'relative-left'}
        layout={'round'}
        trigger={
          <button className={classNames(wrapperCls, activeWrapper)}>
            {myReaction
              ? (
                <ReactionCompact name={myReaction} />
              )
              : isCandlePost
                ? (
                  <ReactionCompact name="DEFAULT_CANDLE" />
                )
                : (
                  <ReactionIcon iconName="heart-outline" />
                )}
            <p className={countCls}>
              {myReaction ? translateReactions(myReaction) : zeroReactionsText}
            </p>
          </button>
        }
      >
        {renderPopoverChildren}
      </Popover>
    </UserOnboardingCTA>
  )
}
